// generated.ts
var queryTypedArguments = {
  orders: {
    limit: "Int",
    offset: "Int"
  },
  unrated_orders: {
    last_ignored: "Float",
    from: "Int",
    to: "Int"
  }
};
export {
  queryTypedArguments
};
//# sourceMappingURL=generated.mjs.map
